import {createSlice, isAnyOf} from '@reduxjs/toolkit';

import {extendedAPI} from './api';

import type {DefaultRootState} from 'react-redux';
import type {UserSerializedType} from 'sweet-types';

export interface UsersState {
  usersById: {
    [id: number]: UserSerializedType;
  };
}

const initialState: UsersState = {
  usersById: {},
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addMatcher(
        extendedAPI.endpoints.users.matchFulfilled,
        (state, {payload: {results}}) => {
          // save slim-tasks by id so we can use them to show some metadata
          // in the detail page while the fat task is fetched
          for (const user of results) {
            state.usersById[user.id] = user;
          }
        }
      )
      .addMatcher(
        isAnyOf(
          extendedAPI.endpoints.updateUser.matchFulfilled,
          extendedAPI.endpoints.userDetails.matchFulfilled
        ),
        (state, {payload: user}) => {
          state.usersById[user.id] = user;
        }
      ),
});

export const usersReducer = usersSlice.reducer;

export const selectUserById =
  (userId: number) =>
  (state: DefaultRootState): UserSerializedType | undefined =>
    state.users.usersById[userId];

export const selectUsersById =
  (userIds: Array<number>) => (state: DefaultRootState) => {
    const users: Array<UserSerializedType> = [];
    const notFound: Array<number> = [];
    const userById = state.users.usersById;
    userIds.forEach((userId) => {
      const user = userById[userId];
      if (user == null) {
        notFound.push(userId);
      } else {
        users.push(user);
      }
    });

    return {
      users,
      notFound,
    };
  };
